import React from "react";
import ButtonPrimary from "../../../elements/button/ButtonPrimary";
import InputSingle from "../../../elements/input/InputSingle";

const BuatInstrumenPertanyaan = () => {
  return (
    <div
      className="w-full flex flex-col dark:text-white pt-16 px-10"
      style={{ minHeight: "100vh" }}
    >
      <div className="flex flex-row justify-between items-center">
        <h1 className="text-xl font-bold">BUAT PERTANYAAN</h1>

        <div className="">
          <ButtonPrimary text="Simpan" type="solid" />
        </div>
      </div>

      <div className="flex flex-col">
        <div className="flex flex-col">
          <p className="my-2">Pertanyaan ke 1</p>

          <div className="flex flex-row gap-2 pr-32">
            <div className="w-8/12">
              <div className="p-4 rounded-lg bg-gray-300 dark:bg-gray-600">
                <p>
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                  Dolorum harum necessitatibus cupiditate distinctio dicta.
                  Nulla natus saepe necessitatibus optio explicabo ipsa? Iusto
                  optio illo, eos odio blanditiis laborum eum quaerat.
                </p>
              </div>
            </div>
            <div className="w-4/12">
              {[...Array(4).keys()].map((x) => {
                return (
                  <div className="flex flex-col my-2">
                    <p>PILIHAN GANDA KE {x + 1}</p>
                    <InputSingle />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuatInstrumenPertanyaan;
